export default __webpack_public_path__ + "static/media/floating-button-icon.7e6c7a33.svg";